import styled from "styled-components";

import { Layout } from "./Layout";
// import { Button } from "./Button";
// import { Menu } from "./Menu";

import {
  Button as antdButton,
  Affix as antdAffix,
  Anchor as antdAnchor,
  AutoComplete as antdAutoComplete,
  Alert as antdAlert,
  Avatar as antdAvatar,
  BackTop as antdBackTop,
  Badge as antdBadge,
  Breadcrumb as antdBreadcrumb,
  Calendar as antdCalendar,
  Card as antdCard,
  Collapse as antdCollapse,
  Carousel as antdCarousel,
  Cascader as antdCascader,
  Checkbox as antdCheckbox,
  Col as antdCol,
  Comment as antdComment,
  ConfigProvider as antdConfigProvider,
  DatePicker as antdDatePicker,
  Descriptions as antdDescriptions,
  Divider as antdDivider,
  Dropdown as antdDropdown,
  Drawer as antdDrawer,
  Empty as antdEmpty,
  Form as antdForm,
  Icon as antdIcon,
  Input as antdInput,
  InputNumber as antdInputNumber,
  List as antdList,
  LocaleProvider as antdLocaleProvider,
  message,
  Menu as antdMenu,
  Mentions as antdMentions,
  Modal as antdModal,
  Statistic as antdStatistic,
  notification,
  PageHeader as antdPageHeader,
  Pagination as antdPagination,
  Popconfirm as antdPopconfirm,
  Popover as antdPopover,
  Progress as antdProgress,
  Radio as antdRadio,
  Rate as antdRate,
  Result as antdResult,
  Row as antdRow,
  Select as antdSelect,
  Skeleton as antdSkeleton,
  Slider as antdSlider,
  Spin as antdSpin,
  Steps as antdSteps,
  Switch as antdSwitch,
  Table as antdTable,
  Transfer as antdTransfer,
  Tree as antdTree,
  TreeSelect as antdTreeSelect,
  Tabs as antdTabs,
  Tag as antdTag,
  TimePicker as antdTimePicker,
  Timeline as antdTimeline,
  Tooltip as antdTooltip,
  Typography as antdTypography,
  Mention as antdMention,
  Upload as antdUpload,
  version as antdversion,
} from "antd";
// "UIKit": "3.24.1",

// put any css from design

const Button = styled(antdButton)``;
const Affix = styled(antdAffix)``;
const Anchor = styled(antdAnchor)``;
const AutoComplete = styled(antdAutoComplete)``;
const Alert = styled(antdAlert)``;
const Avatar = styled(antdAvatar)``;
const BackTop = styled(antdBackTop)``;
const Badge = styled(antdBadge)``;
const Breadcrumb = styled(antdBreadcrumb)``;
const Calendar = styled(antdCalendar)``;
const Card = styled(antdCard)`
  .ant-card-head {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    border-bottom: ${({ theme }) =>
      "1px solid " + theme.PROPERTY.BORDER.WARNING};
  }
  .ant-card {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.INFO};
  }
  .ant-descriptions-bordered .ant-descriptions-item-label {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.DARK};
  }
  .ant-descriptions-bordered .ant-descriptions-item-content {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.SUNSHINE};
  }
  .ant-descriptions-bordered .ant-descriptions-view {
    border: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .ant-descriptions-bordered .ant-descriptions-row:not(:last-child) {
    border-bottom: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .ant-descriptions-bordered .ant-descriptions-item-label:not(:last-child),
  .ant-descriptions-bordered .ant-descriptions-item-content:not(:last-child) {
    border-right: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .ant-empty-normal {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-checkbox-wrapper {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-tabs {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-tabs-nav .ant-tabs-tab-active {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.DARK};
  }
  .ant-tabs-nav .ant-tabs-tab {
    border-top: ${({ theme }) =>
      "1px solid " + theme.PROPERTY.BORDER.SECONDARY};
    border-right: ${({ theme }) =>
      "1px solid " + theme.PROPERTY.BORDER.SECONDARY};
  }
  .ant-tabs-nav .ant-tabs-tab:hover {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    font-weight: 500;
  }
  .ant-tabs-tab-prev,
  .ant-tabs-tab-next {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.SECONDARY};
  }
`;
const Collapse = styled(antdCollapse)``;
const Carousel = styled(antdCarousel)``;
const Cascader = styled(antdCascader)``;
const Checkbox = styled(antdCheckbox)``;
const Col = styled(antdCol)``;
const Comment = styled(antdComment)``;
const ConfigProvider = styled(antdConfigProvider)``;
const DatePicker = styled(antdDatePicker)``;
const Descriptions = styled(antdDescriptions)`
  .ant-descriptions-item-label {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-descriptions-item-content {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
`;
const Divider = styled(antdDivider)``;
const Dropdown = styled(antdDropdown)``;
const Drawer = styled(antdDrawer)`
  .ant-drawer-header {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.SECONDARY};
  }
  .ant-drawer-title {
    color: ${({ theme }) => theme.PROPERTY.COLOR.SECONDARY};
  }
  .ant-drawer-close {
    color: ${({ theme }) => theme.PROPERTY.COLOR.SECONDARY};
  }
  .ant-drawer-content {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.INFO};
  }
  .ant-btn {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.DEFAULT};
    border-color: ${({ theme }) => theme.PROPERTY.BORDER.DEFAULT};
    color: ${({ theme }) => theme.PROPERTY.COLOR.DEFAULT};
  }
  .ant-btn-primary {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.PRIMARY};
    border-color: ${({ theme }) => theme.PROPERTY.BORDER.PRIMARY};
    color: ${({ theme }) => theme.PROPERTY.COLOR.PRIMARY};
  }
  .ant-btn-danger {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.DANGER};
    border-color: ${({ theme }) => theme.PROPERTY.BORDER.DANGER};
    color: ${({ theme }) => theme.PROPERTY.COLOR.DANGER};
  }
  .ant-typography {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .search > input,
  .search .ant-select-selection {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.WARNING};
  }
  .ant-switch-checked {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.SUCCESS};
  }
  .ant-switch {
    border: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.SUCCESS};
  }
  .ant-radio-wrapper {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-checkbox-wrapper {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-upload-list-item-info .anticon-loading,
  .ant-upload-list-item-info .anticon-paper-clip {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-upload-list {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-upload-list-item .anticon-close {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-upload-list-item .anticon-close:hover {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-upload-list-item:hover .ant-upload-list-item-info {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.DARK};
  }
  .has-error .ant-form-explain,
  .has-error .ant-form-split {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  a {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-form-item-required::before {
    color: ${({ theme }) => theme.PROPERTY.BACKGROUND.DANGER};
  }
`;
const Empty = styled(antdEmpty)``;
const Form = styled(antdForm)`
  .ant-form-item-label > label {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-form-item {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
`;
const Icon = styled(antdIcon)``;
const Input = styled(antdInput)``;
const InputNumber = styled(antdInputNumber)``;
const List = styled(antdList)`
  background: ${({ theme }) => theme.PROPERTY.BACKGROUND.INFO};
  .ant-list-item-meta-title {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-empty-normal {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
`;
const LocaleProvider = styled(antdLocaleProvider)``;
const Menu = styled(antdMenu)``;
const Mentions = styled(antdMentions)``;
const Modal = styled(antdModal)``;
const Statistic = styled(antdStatistic)``;
const PageHeader = styled(antdPageHeader)``;
const Pagination = styled(antdPagination)`
  .ant-pagination-item a {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-pagination-disabled a,
  .ant-pagination-disabled:hover a,
  .ant-pagination-disabled:focus a,
  .ant-pagination-disabled .ant-pagination-item-link,
  .ant-pagination-disabled:hover .ant-pagination-item-link,
  .ant-pagination-disabled:focus .ant-pagination-item-link {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    opacity: 0.25;
  }
  .ant-pagination-prev a,
  .ant-pagination-next a {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-ellipsis,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-ellipsis {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    opacity: 0.25;
  }
  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-link-icon {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: ${({ theme }) => theme.PROPERTY.BACKGROUND.PRIMARY};
  }
  .ant-pagination-item-active {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.PRIMARY};
    border-color: ${({ theme }) => theme.PROPERTY.BORDER.PRIMARY};
  }
  .ant-pagination-item-active a {
    color: ${({ theme }) => theme.PROPERTY.COLOR.PRIMARY};
  }
`;
const Popconfirm = styled(antdPopconfirm)``;
const Popover = styled(antdPopover)``;
const Progress = styled(antdProgress)``;
const Radio = styled(antdRadio)``;
const Rate = styled(antdRate)``;
const Result = styled(antdResult)``;
const Row = styled(antdRow)``;
const Select = styled(antdSelect)``;
const Skeleton = styled(antdSkeleton)``;
const Slider = styled(antdSlider)``;
const Spin = styled(antdSpin)``;
const Steps = styled(antdSteps)``;
const Switch = styled(antdSwitch)``;
const Table = styled(antdTable)`
  .ant-table-thead > tr > th {
    color: ${({ theme }) => theme.PROPERTY.COLOR.DARK};
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.DARK};
    border-bottom: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .ant-table-bordered .ant-table-thead > tr > th,
  .ant-table-bordered .ant-table-tbody > tr > td {
    border-right: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .ant-table-bordered .ant-table-header > table,
  .ant-table-bordered .ant-table-body > table,
  .ant-table-bordered .ant-table-fixed-left table,
  .ant-table-bordered .ant-table-fixed-right table {
    border: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
    border-right: 0;
    border-bottom: 0;
  }
  .ant-table-bordered .ant-table-thead > tr:not(:last-child) > th {
    border-bottom: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .ant-table-tbody > tr > td {
    border-bottom: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .ant-table-fixed-left table,
  .ant-table-fixed-right table {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.SUNSHINE};
  }
  .ant-table-fixed-header
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-body {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.SUNSHINE};
  }
  .ant-table {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  tr.ant-table-expanded-row,
  tr.ant-table-expanded-row:hover {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.SUNSHINE};
  }
  .ant-table-thead
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr.ant-table-row-hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-thead
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td,
  .ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.PRIMARY};
    color: ${({ theme }) => theme.PROPERTY.COLOR.PRIMARY};
  }
  .ant-table-header {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.DARK};
  }
  .ant-table-small
    > .ant-table-content
    > .ant-table-header
    > table
    > .ant-table-thead
    > tr
    > th,
  .ant-table-small
    > .ant-table-content
    > .ant-table-body
    > table
    > .ant-table-thead
    > tr
    > th,
  .ant-table-small
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-header
    > table
    > .ant-table-thead
    > tr
    > th,
  .ant-table-small
    > .ant-table-content
    > .ant-table-scroll
    > .ant-table-body
    > table
    > .ant-table-thead
    > tr
    > th,
  .ant-table-small
    > .ant-table-content
    > .ant-table-fixed-left
    > .ant-table-header
    > table
    > .ant-table-thead
    > tr
    > th,
  .ant-table-small
    > .ant-table-content
    > .ant-table-fixed-right
    > .ant-table-header
    > table
    > .ant-table-thead
    > tr
    > th,
  .ant-table-small
    > .ant-table-content
    > .ant-table-fixed-left
    > .ant-table-body-outer
    > .ant-table-body-inner
    > table
    > .ant-table-thead
    > tr
    > th,
  .ant-table-small
    > .ant-table-content
    > .ant-table-fixed-right
    > .ant-table-body-outer
    > .ant-table-body-inner
    > table
    > .ant-table-thead
    > tr
    > th {
    background-color: ${({ theme }) => theme.PROPERTY.BACKGROUND.DARK};
  }
  .ant-table-small {
    border: ${({ theme }) => "1px solid " + theme.PROPERTY.BORDER.DARK};
  }
  .ant-pagination-item a {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-pagination-disabled a,
  .ant-pagination-disabled:hover a,
  .ant-pagination-disabled:focus a,
  .ant-pagination-disabled .ant-pagination-item-link,
  .ant-pagination-disabled:hover .ant-pagination-item-link,
  .ant-pagination-disabled:focus .ant-pagination-item-link {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    opacity: 0.25;
  }
  .ant-pagination-prev a,
  .ant-pagination-next a {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-ellipsis,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-ellipsis {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
    opacity: 0.25;
  }
  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-link-icon,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-link-icon {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
  .ant-pagination-prev:focus .ant-pagination-item-link,
  .ant-pagination-next:focus .ant-pagination-item-link,
  .ant-pagination-prev:hover .ant-pagination-item-link,
  .ant-pagination-next:hover .ant-pagination-item-link {
    color: ${({ theme }) => theme.PROPERTY.BACKGROUND.PRIMARY};
  }
  .ant-pagination-item-active {
    background: ${({ theme }) => theme.PROPERTY.BACKGROUND.PRIMARY};
    border-color: ${({ theme }) => theme.PROPERTY.BORDER.PRIMARY};
  }
  .ant-pagination-item-active a {
    color: ${({ theme }) => theme.PROPERTY.COLOR.PRIMARY};
  }
  a {
    color: ${({ theme }) => theme.PROPERTY.COLOR.INFO};
  }
`;
const Transfer = styled(antdTransfer)``;
const Tree = styled(antdTree)``;
const TreeSelect = styled(antdTreeSelect)``;
const Tabs = styled(antdTabs)``;
const Tag = styled(antdTag)``;
const TimePicker = styled(antdTimePicker)``;
const Timeline = styled(antdTimeline)``;
const Tooltip = styled(antdTooltip)``;
const Typography = styled(antdTypography)``;
const Mention = styled(antdMention)``;
const Upload = styled(antdUpload)``;
const version = styled(antdversion)``;

export {
  Layout,
  Affix,
  Anchor,
  AutoComplete,
  Alert,
  Avatar,
  BackTop,
  Badge,
  Breadcrumb,
  Calendar,
  Card,
  Collapse,
  Carousel,
  Cascader,
  Checkbox,
  Col,
  Comment,
  ConfigProvider,
  DatePicker,
  Descriptions,
  Divider,
  Dropdown,
  Drawer,
  Empty,
  Form,
  Icon,
  Input,
  InputNumber,
  List,
  LocaleProvider,
  message,
  Menu,
  Mentions,
  Modal,
  Statistic,
  notification,
  PageHeader,
  Pagination,
  Popconfirm,
  Popover,
  Progress,
  Radio,
  Rate,
  Result,
  Row,
  Select,
  Skeleton,
  Slider,
  Spin,
  Steps,
  Switch,
  Table,
  Transfer,
  Tree,
  TreeSelect,
  Tabs,
  Tag,
  TimePicker,
  Timeline,
  Tooltip,
  Typography,
  Mention,
  Upload,
  version,
  Button,
};
